import { manifest } from './manifest/manifest'
export default manifest
